import { TableWordNoun, TableWordVerb, Word } from "@model";
import { getLemma } from "./word-tag.helper";

export function findGap(wordAnswers: Word[], errorFunction: () => void, recursionIndex = 0): number {
  if (recursionIndex > 10) {
    errorFunction();
    return 0;
  }

  const gap = Math.floor(Math.random() * 10);
  const variants: Array<keyof Word> = ["adj", "variant_c_pl", "variant_d_pl", "variant_e_pl"];
  const wordsArr = variants.map((variant) => {
    return wordAnswers.map((word) => word[variant]);
  });

  const sets = wordsArr.map((wArr) => {
    const arr = wArr.map((s) => {
      return findGapContent(s as string, gap);
    });

    return new Set([...arr]);
  });

  const anySetShorter = sets.find((g) => g.size !== wordAnswers.length);

  recursionIndex++
  return anySetShorter ? findGap(wordAnswers, errorFunction, recursionIndex) : gap;
}

export function findGapContent(sentence: string, gapNumber: number): string {
  const words = sentence.split(" ");
  const n = gapNumber % words.length;
  return words[n].toLowerCase().replace(".", "").replace("?", "");
}

export function findLastTagWord(tag: string): string {
  const arr = tag.split("_");
  return arr.at(-1) || "";
}

export function getWordsFromSentence(sentence: string): string[] {
  if (!sentence) return [];
  const words = sentence.match(/[\wąćęłńóśźżĄĆĘŁŃÓŚŹŻ]+(?=\s|[.!?]|$)/g) as string[];
  return words.map((w) => w.toLowerCase());
}

export function splitWordsBySpace(sentence: string): string[] {
  if (!sentence) return [];
  return sentence.split(" ");
}

export function matchTagsToWord(words: string[], tags: string[]): Map<string, string | null>[] {
  // if (!tags.length) return words;

  const tagsMaps = tags
    .map((tag) => {
      const lemma = getLemma(tag);
      if (lemma) {
        return new Map<string, string>([[lemma, tag]]);
      } else {
        return null;
      }
    })
    .filter((map) => !!map) as NonNullable<Map<string, string>[]>;

  const wordWithTagMapsArray = tagsMaps.map((tagMap) => {
    const lemma = [...tagMap.keys()][0];
    const tag = [...tagMap.values()][0];

    // searching for exact word
    const lastTagWord = findLastTagWord(tag);
    const found = words.find((w) => {
      return w === lastTagWord;
    });
    if (found) {
      return new Map([[found, tag]]);
    }

    // searching similar word
    let matches: string[] = [];
    let letters = "";
    let i = 0;

    while ((matches.length > 1 || i === 0) && i < 20) {
      if (i === 19) {
        console.log("long iteration");
      }
      i++;
      letters = lemma.slice(0, i);
      matches = words.filter((word) => {
        return word.slice(0, i) === letters;
      });
    }

    return new Map([[matches[0], tag]]);
  });

  const wordMaps = words.map((word) => {
    const tag = wordWithTagMapsArray.find((w) => {
      return [...w.keys()][0] === word;
    });

    return new Map([[word, tag ? [...tag.values()][0] : null]]);
  });

  return wordMaps;
}

export function hasInValues(tableWords: Array<TableWordVerb | TableWordNoun>, tag: string): boolean  {
  const lemma = getLemma(tag);
  // @ts-ignore
  const allValues: string[] = tableWords.reduce((a, b) => {
    return [...a, ...Object.values(b)];
  }, []) as unknown as string[];
  return allValues.includes(lemma)
}
